var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagingTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3312 0.0666855C21.0268 -0.119431 20.639 0.106431 20.639 0.467151L20.639 4.54361L18.5003 6.09421L16.3616 4.54361V0.46715C16.3616 0.104237 15.9708 -0.117512 15.6643 0.0697002C14.0676 1.0466 13.0003 2.82334 13 4.85307C13 7.02616 14.2572 8.90021 16.0559 9.82119L16.0559 21.5194C16.0559 22.8893 17.1502 24 18.5 24C19.8498 24 20.9441 22.8893 20.9441 21.5194L20.9441 9.83106C22.749 8.91528 24 7.04097 24 4.85362C24 2.82142 22.93 1.04304 21.3312 0.0666855ZM19.1482 22.1767C18.7903 22.5399 18.2097 22.5399 17.8518 22.1767C17.4937 21.8132 17.494 21.2242 17.8518 20.861C18.2097 20.4978 18.7901 20.4975 19.1482 20.861C19.506 21.2242 19.506 21.8135 19.1482 22.1767Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.875C0 2.90909 0.897772 2 1.81818 2H12C11.7758 2.33623 11.6002 2.6292 11.463 2.90909H1.81818C1.36364 2.90909 0.909091 3.36364 0.909091 3.81818V20.1818C0.909091 20.6364 1.36364 21.0909 1.81818 21.0909H14V22L1.81818 22C0.909091 22 0 21.1023 0 20.1818V3.875ZM11.1374 3.81818C11.058 4.16535 11.0182 4.54154 11 5C11.211 7.4265 11.7416 9.08358 14 10.5V13.2727L12.7273 12L10.9091 13.8182L8.18182 10.1818L1.81818 17.4545V4.72727C1.81818 4.27273 2.27273 3.81818 2.72727 3.81818H11.1374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagingTools);
export default __webpack_public_path__ + "static/media/ImagingTools.2cdda245fe64e4b0ec05b05a2c8d42a4.svg";
export { ForwardRef as ReactComponent };